import { Component } from 'react';
import styled from '@emotion/styled';
import { ASSET_URLS } from '../utils';
import Page from '../page';
import WarrantyFooter from '../footer';
import { warranty_documents } from './data.js';

const { PDFIcon } = ASSET_URLS;

const DocumentList = styled.div`
  list-style-type: none;
  padding: 0;
  @media (min-width: 1032px) {
    height: 864px;
  }
`;

const DocumentTitle = styled.div`
  height: 21px;
  font-family: OCRoboto;
  font-weight: bold;
  color: #000000;

  @media (max-width: 320px) {
    font-size: 11px;
  }
  @media (min-width: 321px) and (max-width: 375px) {
    font-size: 11px;
  }
  @media (min-width: 376px) and (max-width: 425px) {
    font-size: 13px;
  }
  @media (min-width: 426px) {
    font-size: 16px;
  }
`;

const DocumentLanguage = styled.span`
  height: 20px;
  font-family: OCRoboto;
  font-size: 15px;
  color: #000000;

  @media (max-width: 320px) {
    font-size: 10px;
  }
  @media (min-width: 321px) and (max-width: 375px) {
    font-size: 10px;
  }
  @media (min-width: 376px) and (max-width: 425px) {
    font-size: 12px;
  }
  @media (min-width: 426px) {
    font-size: 14px;
  }
`;

const DocumentSize = styled.span`
  height: 15px;
  font-family: OCRoboto;
  font-weight: bold;
  color: #727272;

  @media (max-width: 320px) {
    font-size: 9px;
  }
  @media (min-width: 321px) and (max-width: 375px) {
    font-size: 9px;
  }
  @media (min-width: 376px) and (max-width: 425px) {
    font-size: 10px;
  }
  @media (min-width: 426px) {
    font-size: 11px;
  }

`;

const DocumentLink = styled.a`
  &:hover {
    text-decoration: underline;
    color: #ce1126;
  }
`;


export default class DocumentPage extends Component {

  constructor(props) {
    super(props);
  }
  renderWarrantyDocuments(docs) {
    let documents = docs.map( (doc, index) => {
      return (
          <DocumentLink key={index} href={doc['href']} target="_blank" style={{ marginRight: '15px'}} data-track='file-download'>
            <img src={PDFIcon} alt="PDF Document" style={{marginRight: '7px'}} />
            <DocumentLanguage>{doc['lang']}</DocumentLanguage>&nbsp;
            <DocumentSize>{doc['size']}</DocumentSize>
          </DocumentLink>
      )
    });
    return (<p>{documents}</p>);
  }

  renderDocumentList() {
    let documents = [];
        warranty_documents.forEach( (warranty, warrantyIndex) => {
            documents.push(
              <li style={{marginBottom: '14px'}}>
                <DocumentTitle>{ warranty['title'] }</DocumentTitle>
                { this.renderWarrantyDocuments(warranty['documents']) }
              </li>
            );
        });
    return (
      <div>
        { documents }
      </div>
    )
  }

  render() {
    return(
      <Page
        style={{
          marginRight: '10px',
          marginTop: '10px',
      }}>
        <DocumentList
          style={{
            paddingLeft: '20px',
            paddingTop: '20px',
        }}>
          { this.renderDocumentList() }
        </DocumentList>
      <WarrantyFooter />
      </Page>
    )
  }
}